<template>
  <nav class="navbar navbar-expand-md navbar-bg navbar-dark">
    <button
      class="navbar-toggler"
      :class="{ collapsed: !show }"
      type="button"
      @click="show = !show"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse d-flex align-items-center" :class="{ show: show }">
      <inputsForms />
      
      <button 
        class="btn ghost-btn" 
        @click="toggleGhostPlayers" 
        :title="isGhostsHidden ? 'Показать всех игроков' : 'Скрыть пустых игроков (без номера, цены и игр)'"
        :class="{'is-active': isGhostsHidden}"
      >
        <svg v-if="!isGhostsHidden" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
          <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
          <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
          <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"/>
          <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"/>
          <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"/>
        </svg>
      </button>

      <button 
        class="btn screenshot-btn" 
        @click="triggerScreenshot" 
        title="Сделать скриншот таблиц"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
          <path d="M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1v6zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2z"/>
          <path d="M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/>
        </svg>
      </button>
      
      <button 
        class="btn copy-match-btn" 
        @click="copyMatchToClipboard" 
        title="Копировать Team A - Team B"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
          <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
          <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
        </svg>
      </button>

      <TmSelectors 
        @league-selected="onLeagueSelected" 
        @load-matches="fetchMatchdays" 
      />

      <button 
        class="btn fav-star-btn" 
        @click="addFavorite" 
        :disabled="!currentLeague"
        :title="isCurrentLeagueFavorite ? 'Уже в избранном' : 'Добавить в избранное'"
      >
        {{ isCurrentLeagueFavorite ? '⭐' : '☆' }}
      </button>

      <div class="custom-fav-container" v-click-outside="closeFavorites">
        <div class="custom-fav-toggle form-control" @click="showFavorites = !showFavorites" :class="{'is-open': showFavorites}">
          <div class="fav-toggle-content">
            <span class="fav-toggle-title" :title="selectedFavorite ? selectedFavorite.name : 'Избранные лиги'">
              {{ selectedFavorite ? selectedFavorite.name : 'Избранные лиги' }}
            </span>
            <span class="fav-badge" v-if="favorites.length > 0">{{ favorites.length }}</span>
          </div>
          <span class="custom-fav-arrow" :class="{'arrow-up': showFavorites}">▼</span>
        </div>

        <transition name="fade-dropdown">
          <div class="custom-fav-menu" v-if="showFavorites">

            <div v-if="favorites.length === 0" class="custom-fav-empty">
              <div class="empty-icon">⭐</div>
              <p class="empty-title">Нет избранных лиг</p>
              <span class="empty-desc">Нажмите звездочку рядом с лигой, чтобы добавить её сюда</span>
            </div>

            <div v-else class="custom-fav-list">
              <div v-for="group in groupedFavorites" :key="group.countryName" class="fav-country-group">
                
                <div class="fav-country-header" @click.stop="toggleCountry(group.countryName)">
                  <span class="fav-country-title">{{ group.countryName }}</span>
                  <span class="fav-country-arrow" :class="{'is-open': isCountryOpen(group.countryName)}">▼</span>
                </div>

                <ul class="fav-leagues-list" v-show="isCountryOpen(group.countryName)">
                  <li v-for="fav in group.leagues" :key="fav.id" class="custom-fav-item">
                    <div class="fav-text-wrapper" @click="onFavoriteSelected(fav)">
                      <span class="fav-name">{{ fav.name }}</span>
                    </div>
                    <button class="fav-delete-btn" @click.stop="removeFavorite(fav.id)" title="Удалить лигу">
                      &times;
                    </button>
                  </li>
                </ul>

              </div>
            </div>
          </div>
        </transition>
      </div>

      <div class="match-count">
        <label for>Кол-во. Матчей</label>
        <div class="match-count-wrapper">
          <input
            type="number"
            min="0"
            max="15"
            class="form-control match-count-input"
            placeholder="Матчей"
            v-model="matchCount"
          />
          <button class="btn reparse-btn" @click="reparseCurrentMatch" title="Перепарсить матч с новым количеством">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"/>
              <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
    
    <span
      @click="$emit('settingsShow')"
      class="nav-link onHover positionCorrection"
      v-if="premissions === 'test'"
    >
      <img :src="settingsImg" alt="setting img" />
    </span>
    
    <span
      @click="$emit('groupShow')"
      class="nav-link onHover positionCorrection"
      v-if="premissions === 'admin'"
    >
      <img :src="groupImg" alt="group img" />
    </span>

    <span class="nav-link onHover positionCorrection" @click="exit()">
      <img :src="exitImg" alt="exit img" />
    </span>
  </nav>
</template>

<script>
import exitImg from "../assets/img/exit.svg";
import settingsImg from "../assets/img/settings.svg";
import groupImg from "../assets/img/group.svg";
import inputsForms from "../components/InputForms";
import TmSelectors from "../components/TmSelectors.vue"; 

export default {
  name: "navbars",
  components: { 
    inputsForms, 
    TmSelectors 
  },
  data: () => ({
    settingsImg,
    exitImg,
    groupImg,
    currentLeague: null, 
    favorites: [],
    showFavorites: false,
    selectedFavorite: null,
    openCountries: [] 
  }),
 
  created() {
    this.loadFavorites();
  },
  methods: {
    // 🔥 НОВЫЙ МЕТОД: Переключатель глазика (отправляем в хранилище)
    toggleGhostPlayers() {
      this.$store.commit('SET_HIDE_GHOST_PLAYERS', !this.isGhostsHidden);
    },

    async loadFavorites() {
      try {
        const { data } = await this.$axios.post('/localstorage/batch', 
          { keys: ['user_favorite_leagues'] }, 
          { headers: { Authorization: this.$cookie.get('token') } }
        );
        
        if (data && data['user_favorite_leagues']) {
          this.favorites = JSON.parse(data['user_favorite_leagues']);
        } else {
          this.favorites = [];
        }
      } catch (error) {
        console.error("Ошибка загрузки избранных лиг с сервера:", error);
      }
    },

    saveFavoritesToBackend() {
      this.$axios.post('/localstorage', { 
        key: 'user_favorite_leagues', 
        value: JSON.stringify(this.favorites) 
      }, { 
        headers: { Authorization: this.$cookie.get('token') } 
      }).catch(err => console.error("Ошибка сохранения избранных лиг на сервер:", err));
    },

    copyMatchToClipboard() {
      if (!this.matches || this.isEmptyObject(this.matches.teamA) || this.isEmptyObject(this.matches.teamB)) {
        alert("Матч еще не загружен!");
        return;
      }

      const teamA = this.matches.teamA.name || "Team A";
      const teamB = this.matches.teamB.name || "Team B";
      const textToCopy = `${teamA} - ${teamB} не инт`;

      navigator.clipboard.writeText(textToCopy).then(() => {
        console.log("Скопировано:", textToCopy);
      }).catch(err => {
        console.error("Ошибка копирования в буфер:", err);
        alert("Не удалось скопировать в буфер обмена.");
      });
    },

    triggerScreenshot() {
      this.$root.$emit('request-screenshot');
    },
    
    exit() {
      this.$cookie.delete("token");
      location.reload();
    },
    
    async reparseCurrentMatch() {
      if (!this.matches || (this.isEmptyObject(this.matches.teamA) && this.isEmptyObject(this.matches.teamB))) {
        alert("Сначала загрузите матч, чтобы его перепарсить!");
        return;
      }

      console.log(`🚀 Начинаем перепарсинг! Подтягиваем ${this.matchCount} последних игр...`);

      
      // ==========================================
      // ВЕТКА 1: КАСТОМНЫЕ МАТЧИ
      // ==========================================
      
      if (this.matches.competition === "Custom Match") {
        const matchId = this.matches.id;

        const urlA = localStorage.getItem(`custom_urlA_${matchId}`) || this.matches.teamA.href;
        const urlB = localStorage.getItem(`custom_urlB_${matchId}`) || this.matches.teamB.href;
        
        // 🔥 ДОСТАЕМ СОХРАНЕННЫЕ ТУРНИРЫ (С СЕЗОНАМИ) ИЗ ТАЙНИКА
        const tourA = localStorage.getItem(`custom_tourA_${matchId}`) || "";
        const tourB = localStorage.getItem(`custom_tourB_${matchId}`) || "";

        if (!urlA || !urlB) {
          alert("Не удалось найти ссылки на команды для этого кастомного матча.");
          return;
        }

        try {
          this.$store.commit('SET_PRELOADER', true);
          
          const { data } = await this.$axios.post('parseTeams', { 
            urlA: urlA,
            urlB: urlB,
            // 👇 ТЕПЕРЬ ОТПРАВЛЯЕМ ТУРНИРЫ НА СЕРВЕР ПРИ ПЕРЕПАРСИНГЕ!
            tournamentA: tourA,
            tournamentB: tourB,
            count: this.matchCount 
          });

          if(data.error){
            alert(`${data.error}. Попробуй еще раз!`);
            this.$store.commit('SET_PRELOADER', false);
            return;
          }

          data.teamA.comment = '';
          data.teamA.addsquad = [];
          data.teamB.comment = '';
          data.teamB.addsquad = [];

          data.id = matchId;
          data.competition = 'Custom Match';

          this.$store.commit('SET_MATCH', data);
          await this.$store.dispatch("ADD_SAVED_MATCHES", { ...data });

        } catch (error) {
          console.error("Ошибка при обновлении кастомного матча:", error);
          alert("Ошибка при парсинге кастомного матча.");
        } finally {
          this.$store.commit('SET_PRELOADER', false);
        }
        
        return; 
      }

      let exactUrl = "";
      let rawUrl = this.matches.matchUrl || this.matches.url;

      if (!rawUrl || rawUrl.includes('/verein/')) {
        const secretKey = `tm_url_${this.matches.teamA.name}_${this.matches.teamB.name}`;
        rawUrl = localStorage.getItem(secretKey);
      }

      if (rawUrl && !rawUrl.includes('/verein/')) {
        const cleanUrl = rawUrl.split('?')[0]; 
        const idMatch = cleanUrl.match(/\/(\d+)\/?$/); 
        if (idMatch && idMatch[1]) {
          exactUrl = `https://www.transfermarkt.com/spielbericht/index/spielbericht/${idMatch[1]}`;
        }
      }

      if (!exactUrl) {
        alert("Оригинальная ссылка на матч не найдена в базе.\n\nПожалуйста, вставьте ссылку на матч заново.");
        return;
      }
      
      try {
        // Перепарсиваем за ТОТ ЖЕ сезон, иначе запись уехала бы на текущий
        // и в списке появилась бы лишняя копия матча
        const seasonValue = this.matches.seasonValue || "";

        const parsedMatch = await this.$store.dispatch("PARSE_URL", {
          url: exactUrl,
          team: "match",
          count: this.matchCount,
          tournament: seasonValue
        });

        parsedMatch.seasonValue = seasonValue;
        parsedMatch.seasonLabel = this.matches.seasonLabel || "";

        const activeId = localStorage.getItem('active_league_id');
        const activeName = localStorage.getItem('active_league_name');
        if (activeId) parsedMatch.competitionId = activeId;
        if (activeName) parsedMatch.competition = activeName;

        await this.$store.dispatch("ADD_SAVED_MATCHES", { ...parsedMatch });
      } catch (error) {
        console.error("Ошибка при обновлении матча:", error);
      }
    },

    toggleCountry(countryName) {
      const index = this.openCountries.indexOf(countryName);
      if (index > -1) {
        this.openCountries.splice(index, 1); 
      } else {
        this.openCountries.push(countryName); 
      }
    },
    isCountryOpen(countryName) {
      return this.openCountries.includes(countryName);
    },
    
    onLeagueSelected(league, country) {
      const leagueName = league ? league.name : "Неизвестно";
      const leagueId = league ? league.id : "Нет ID";
      
      this.currentLeague = league; 
      this.selectedFavorite = null; 
      
      if (country && this.currentLeague) {
        this.currentLeague.countryName = typeof country === 'string' ? country : country.name;
      }

      if (this.currentLeague) {
          const cName = this.currentLeague.countryName || "";
          const fullName = cName ? `${cName} - ${this.currentLeague.name}` : this.currentLeague.name;
          localStorage.setItem('active_league_id', this.currentLeague.id);
          localStorage.setItem('active_league_name', fullName);
      }
    },
    
    addFavorite() {
      if (!this.currentLeague) return;
      
      const index = this.favorites.findIndex(f => f.id === this.currentLeague.id);
      
      if (index === -1) {
        const country = this.currentLeague.countryName || this.currentLeague.country || this.currentLeague.country_name || "";
        this.favorites.push({
          id: this.currentLeague.id,
          name: this.currentLeague.name,
          url: this.currentLeague.url,
          country: country
        });
        this.saveFavoritesToBackend();
      }
    },

    removeFavorite(id) {
      this.favorites = this.favorites.filter(f => f.id !== id);
      this.saveFavoritesToBackend();
      
      if (this.selectedFavorite && this.selectedFavorite.id === id) {
        this.selectedFavorite = null;
      }
    },

    onFavoriteSelected(fav) {
      this.selectedFavorite = fav; 
      this.fetchMatchdays(fav);
      this.showFavorites = false; 
    },

    closeFavorites() {
      this.showFavorites = false;
    },
    
    // Дата из ТМ: "Fri 24/07/2026" или "Fri 24/07/2026 6:00 PM". Не разобрали — вернём null
    parseTmDate(text) {
      // Год бывает и четырёхзначным («15/09/2026»), и двузначным: полный календарь
      // сезона пишет «Tue 15/09/26». Второй формат фильтр не понимал, все даты
      // считались нераспознанными — и в таблице оставался весь сезон
      const m = String(text || "").match(/(\d{1,2})[./](\d{1,2})[./](\d{4}|\d{2})(?!\d)/);
      if (!m) return null;
      const year = m[3].length === 2 ? 2000 + Number(m[3]) : Number(m[3]);
      const d = new Date(year, Number(m[2]) - 1, Number(m[1]));
      return isNaN(d.getTime()) ? null : d;
    },

    // Оставляем текущий тур и неделю вперёд. Полный календарь кубка отдаёт сразу
    // весь сезон — сотня матчей за три недели, работать с этим невозможно.
    keepCurrentWeek(matches) {
      // Бэкенд уже вырезал из календаря сезона ближайший тур и следующий (у матчей
      // проставлен номер тура) — резать это ещё и по датам нельзя: тур нередко
      // растянут на неделю с лишним, и половина матчей просто исчезала
      if (matches.some(m => m && m.matchday)) return matches;

      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const limit = new Date(today);
      limit.setDate(limit.getDate() + 7);

      // Матчи без распознанной даты не выбрасываем: у обычных лиг формат может
      // отличаться, и лучше показать лишнее, чем потерять нужное
      const undated = matches.filter(m => !this.parseTmDate(m.date));
      const dated = matches.filter(m => this.parseTmDate(m.date));

      const inWindow = dated.filter(m => {
        const d = this.parseTmDate(m.date);
        return d >= today && d <= limit;
      });

      if (inWindow.length > 0) return [...inWindow, ...undated];

      // Ближайший тур дальше недели — показываем его целиком, иначе список будет пуст
      const upcoming = dated.filter(m => this.parseTmDate(m.date) >= today);
      if (upcoming.length > 0) {
        const nearest = Math.min(...upcoming.map(m => this.parseTmDate(m.date).getTime()));
        return [...upcoming.filter(m => this.parseTmDate(m.date).getTime() === nearest), ...undated];
      }

      return matches;
    },

    async fetchMatchdays(league) {
      // Календарь может грузиться до 45 секунд, а при повторах и дольше.
      // Молчащая крутилка за это время читается как зависание, поэтому подпись меняем
      this.$store.commit("SET_PRELOADER", true);
      this.$store.commit("SET_PRELOADER_TEXT", "Загружаем календарь…");

      const timers = [
        setTimeout(() => this.$store.commit("SET_PRELOADER_TEXT", "Страница большая, ещё грузим…"), 10000),
        setTimeout(() => this.$store.commit("SET_PRELOADER_TEXT", "Transfermarkt отвечает медленно, пробуем ещё раз…"), 30000)
      ];

      try {
        const response = await this.$axios.get(`/tm/matchdays`, {
          params: {
             competitionId: league.id, 
             url: league.url 
          }
        });

        let matchesData = [];
        
        if (response.data && response.data.html) {
          matchesData = response.data.html;
        } else {
          matchesData = response.data;
        }

        if (Array.isArray(matchesData)) {
            matchesData = matchesData.map(match => ({
                ...match,
                competitionId: league.id
            }));
            matchesData = this.keepCurrentWeek(matchesData);
        }

        this.$store.commit("SET_MATCHDAY_HTML", matchesData);

      } catch (error) {
        console.error("Ошибка при загрузке матчей:", error);
        alert("Не удалось загрузить календарь. Попробуйте ещё раз.");
      } finally {
        timers.forEach(clearTimeout);
        this.$store.commit("SET_PRELOADER", false);
      }
    },

    isEmptyObject(obj) {
      return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
    }
  },
  props: {
    show: { type: Boolean, default: false },
  },
  computed: {
    // 🔥 НОВОЕ ВЫЧИСЛЯЕМОЕ СВОЙСТВО: Берем статус из хранилища Vuex
    isGhostsHidden() {
      // Если в store еще нет этой переменной, возвращаем false (по умолчанию выключено)
      return this.$store.state.hideGhostPlayers || false;
    },

    groupedFavorites() {
      const groups = {};
      this.favorites.forEach(fav => {
        const country = fav.country || 'ДРУГИЕ';
        if (!groups[country]) {
          groups[country] = {
            countryName: country,
            leagues: []
          };
        }
        groups[country].leagues.push(fav);
      });
      return Object.values(groups).sort((a, b) => a.countryName.localeCompare(b.countryName));
    },
    isCurrentLeagueFavorite() {
      if (!this.currentLeague) return false;
      return this.favorites.some(f => f.id === this.currentLeague.id);
    },
    matches() {
      return this.$store.getters.matches;
    },
    matchCount: {
      get() {
        return this.$store.getters.matchCount;
      },
      set(val) {
        this.$store.commit("matchCount", val);
      },
    },
    premissions() {
      return this.$store.getters.premissions;
    },
  },
  directives: {
    clickOutside: {
      bind(el, binding) { 
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event);
          }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
      },
      unbind(el) { 
        document.body.removeEventListener('click', el.clickOutsideEvent);
      }
    }
  }
};
</script>

<style lang="sass">
@import "../assets/vars"

nav
  grid-area: navbars
  position: relative
  z-index: 9999
  overflow: visible !important

.navbar-bg
  background-color: rgba($RoundGreen, .3)
  .navbar-nav
    margin: 0 30px
.nav-link
  color: $aside_bg !important
  border-bottom: 2px solid transparent
  transition: all .3s linear
  margin: 0 10px
  img
    height: 20px
    &:hover
      border-bottom: 2px solid $aside_bg

.fav-country-group
  border-bottom: 1px solid #f0f0f0

.fav-country-header
  display: flex
  justify-content: space-between
  align-items: center
  padding: 8px 15px
  background-color: #f1f3f5
  cursor: pointer
  user-select: none
  transition: background-color 0.2s

  &:hover
    background-color: #e9ecef

.fav-country-title
  font-size: 12px
  font-weight: bold
  color: #333
  text-transform: uppercase
  letter-spacing: 0.5px

.fav-country-arrow
  font-size: 10px
  color: #666
  transition: transform 0.3s
  &.is-open
    transform: rotate(180deg)

.fav-leagues-list
  list-style: none
  margin: 0
  padding: 0
  background: #fff

.custom-fav-list .custom-fav-item
  padding-left: 25px 

/* 🔥 НОВЫЕ СТИЛИ ДЛЯ КНОПКИ ГЛАЗИКА 🔥 */
.ghost-btn
  background-color: #17a2b8 /* Цвет по умолчанию (сине-зеленый) */
  color: white
  border: none
  margin: 0 5px 0 15px !important /* Отступ слева от формы ввода */
  height: 38px
  width: 38px
  display: flex !important
  align-items: center !important 
  justify-content: center !important 
  border-radius: 4px
  cursor: pointer
  padding: 0 !important 
  transition: background-color 0.2s ease, transform 0.2s
  svg
    margin: 0
    display: block
  &:hover
    background-color: #117a8b
    transform: scale(1.05)
  &.is-active
    background-color: #dc3545 /* Красный цвет, когда глаз закрыт (фильтр включен) */
    &:hover
      background-color: #c82333

.screenshot-btn
  background-color: #007bff
  color: white
  border: none
  margin: 0 5px !important 
  height: 38px
  width: 38px
  display: flex !important
  align-items: center !important 
  justify-content: center !important 
  border-radius: 4px
  cursor: pointer
  padding: 0 !important 
  transition: background-color 0.2s ease, transform 0.2s
  svg
    margin: 0
    display: block
  &:hover
    background-color: #0056b3
    transform: scale(1.05)

.copy-match-btn
  background-color: #6c757d
  color: white
  border: none
  margin: 0 5px !important 
  height: 38px
  width: 38px
  display: flex !important
  align-items: center !important 
  justify-content: center !important 
  border-radius: 4px
  cursor: pointer
  padding: 0 !important 
  transition: all 0.2s ease
  &:hover
    background-color: #5a6268
    transform: scale(1.05)
  &:active
    background-color: #28a745

.fav-star-btn
  background: #fff
  border: 1px solid #ced4da
  font-size: 20px
  line-height: 1
  padding: 3px 8px
  margin-left: 5px
  border-radius: 4px
  cursor: pointer
  transition: all 0.2s
  color: #555
  &:hover:not(:disabled)
    transform: scale(1.1)
    border-color: #a0a0a0
  &:disabled
    opacity: 0.5
    cursor: not-allowed

.custom-fav-container
  position: relative
  margin-left: 15px
  min-width: 215px 
  max-width: 250px 

.custom-fav-toggle
  display: flex
  justify-content: space-between
  align-items: center
  cursor: pointer
  background: #fff
  user-select: none
  height: 40px
  border: 1px solid #ced4da
  transition: all 0.2s
  &.is-open
    border-color: #80bdff
    box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25)

.fav-toggle-content
  display: flex
  align-items: center
  overflow: hidden

.fav-toggle-title
  color: #495057
  font-size: 14px
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis
  max-width: 145px
  display: inline-block
  vertical-align: middle

.fav-badge
  background-color: #17a2b8
  color: #fff
  font-size: 11px
  font-weight: bold
  padding: 2px 6px
  border-radius: 10px
  margin-left: 8px
  flex-shrink: 0

.custom-fav-arrow
  font-size: 10px
  color: #888
  transition: transform 0.3s
  margin-left: 8px
  &.arrow-up
    transform: rotate(180deg)

.custom-fav-menu
  position: absolute
  top: calc(100% + 5px)
  left: 0
  width: 100%
  background: #fff
  border: 1px solid #e0e0e0
  box-shadow: 0 10px 25px rgba(0,0,0,0.1)
  border-radius: 6px
  z-index: 10000
  overflow: hidden

.custom-fav-empty
  padding: 25px 15px
  text-align: center
  .empty-icon
    font-size: 30px
    margin-bottom: 5px
    opacity: 0.5
  .empty-title
    margin: 0
    font-weight: bold
    color: #555
  .empty-desc
    font-size: 12px
    color: #999
    line-height: 1.2
    display: block
    margin-top: 5px

.custom-fav-list
  list-style: none
  margin: 0
  padding: 0
  max-height: 320px
  overflow-y: auto

.custom-fav-item
  display: flex
  justify-content: space-between
  align-items: center
  padding: 10px 15px
  border-bottom: 1px solid #f0f0f0
  transition: background 0.2s
  &:last-child
    border-bottom: none
  &:hover
    background: #f8f9fa

.fav-text-wrapper
  flex-grow: 1
  cursor: pointer
  display: flex
  flex-direction: column
  justify-content: center

.fav-country
  font-size: 11px
  color: #888
  text-transform: uppercase
  letter-spacing: 0.5px
  margin-bottom: 2px

.fav-name
  color: #005f90
  font-size: 14px
  font-weight: bold

.fav-text-wrapper:hover .fav-name
  text-decoration: underline

.fav-delete-btn
  background: transparent
  border: none
  color: #ccc
  font-size: 20px
  cursor: pointer
  padding: 0 5px
  border-radius: 4px
  transition: all 0.2s
  line-height: 1
  margin-left: 10px
  &:hover
    color: #dc3545
    background: #ffeeee

.match-count-wrapper
  display: flex
  align-items: center

.reparse-btn
  background-color: #28a745
  color: white
  border: none
  margin-left: 5px !important
  height: 38px
  width: 38px
  display: flex !important
  align-items: center !important 
  justify-content: center !important 
  border-radius: 4px
  cursor: pointer
  padding: 0 !important 
  transition: background-color 0.2s ease
  svg
    margin: 0 !important 
    display: block
    transition: transform 0.3s ease
  &:hover
    background-color: #218838
    svg
      transform: rotate(180deg)

.fade-dropdown-enter-active, .fade-dropdown-leave-active
  transition: opacity 0.2s, transform 0.2s

.fade-dropdown-enter, .fade-dropdown-leave-to
  opacity: 0
  transform: translateY(-10px)

.match-count
  display: flex
  text-align: left !important
  margin-left: 25px !important
  position: relative
  label
    position: relative
    top: 7px
    margin-right: 10px
    white-space: nowrap
  .match-count-input
    width: 90px

.navbar-toggler-icon
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e") !important

@media (min-width: 1551px)
  .positionCorrection
    right: 0 /* Прижимает кнопки к правому краю на больших экранах */
    position: relative
    margin-left: auto

@media (max-width: 1550px)
  .positionCorrection
    right: 0
    margin-left: auto
  .nav-link
    padding: 1.0em 0
</style>